import React from 'react';
import styles from './styles/XPalette.module.scss';
import { XComponent } from './components/commons/XComponent';
import { IComponentState } from './components/commons/IComponentState';
import { IComponentProps } from './components/commons/IComponentProps';
import { XColumn } from './components/layouts/XColumn';
import { XRow } from './components/layouts/XRow';
import { EMargin } from './types/enums/EMargin';
import { XPaletteItem } from './XPaletteItem';

export interface IPaletteProps extends IComponentProps {
    isRed?: boolean | undefined;
    isBlue?: boolean | undefined;
    isGreen?: boolean | undefined;
    part?: string | undefined;
}

export interface IPaletteState extends IComponentState {
}

export class XPalette extends XComponent<HTMLDivElement, IPaletteProps, IPaletteState> {
    static defaultProps = {
        ...XComponent.defaultProps,
        part: 'FF'
    }
    static indexes: string[] = ['00', '11', '22', '33', '44', '55', '66', '77', '88', '99', 'AA', 'BB', 'CC', 'DD', 'EE', 'FF'];
    public constructor(props: IPaletteProps) {
        super(props);
    }
    
    componentDidMount(): void{}
    componentWillUnmount(): void{}
    //<div className={this.cn(styles.XPaletteItem)}>{this.props.children}</div>
    color(i: string | undefined, j: string, k: string) {
        if(this.props.isRed)
            return i + j + k;
        if(this.props.isGreen)
            return j + i + k;
        if(this.props.isBlue)
            return j + k + i;
    }
    render(): React.ReactNode {
        return (
            <XColumn>
                {React.Children.map(XPalette.indexes, (x) =>
                    <XRow>
                        {React.Children.map(XPalette.indexes, (y) =>
                            <XPaletteItem
                                margin='2px'
                                color={'#' + this.color(this.props.part, x, y)}
                                text={this.color(this.props.part, x, y)}
                                />
                            )}
                    </XRow>
                )}
            </XColumn>
        );
    }
}
